<template>
  <div class="printbox" id="printbox">
    <el-form :inline="true" :model="list" status-icon :rules="rules" ref="list" label-width="100px" class="demo-ruleForm my">
      <div class="butbox clearfix" v-if="obj.flag">
        <el-form :inline="true" class="demo-form-inline clearfix">
          <el-form-item class="tinp" label="盘点货位：" prop="houtpositionname">
            <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" placeholder="请选择盘点货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" class="el-form-item" size="small" icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="getList">搜索</el-button>
          <!-- <el-button type="primary" class="fr" size="small" icon="el-icon-printer" @click="print" style="margin:0 10px 10px"  v-loading.fullscreen.lock="fullscreenLoading">打印盘点单</el-button> -->
          <el-button type="warning" class="el-form-item" size="small" icon="el-icon-printer" @click="exportPresentSock3" style="margin:0 10px 10px"  v-loading.fullscreen.lock="fullscreenLoading">导出盘点单</el-button>
          <!--          <a href="" class="content-a-upload ">-->
          <div class="content-a-upload ">
          <input type="file" @change="importf(this)" id="uploadFile" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>请选择导入文件
          </div>
          <!--          </a>-->
          <el-button type="primary" class="fr" style="margin-right: 20px" size="" v-loading.fullscreen.lock="fullscreenLoading" @click="submitForm('list')">提交盘点单</el-button>
          <!-- <el-button v-if="list.savenum<1||list.savenum ==null||list.savenum==''||list.savenum==undefined" type="warning" class="fr" style="margin-right: 20px" size="small" @click="saveForm('list')">保存</el-button> -->
          <!--  <el-button v-else type="warning" disabled class="fr" style="margin-right: 20px" size="small" @click="saveForm('list')">保存</el-button> -->
        </el-form>
        <!-- <div class="huol fl">
                    货位：round
                    <el-input v-on:change="onParamChange" placeholder="请输入内容" v-model="clocationid" suffix-icon="el-icon-search" style="width: 260px" clearable>
                    </el-input>
                </div> -->
      </div>
      <div class="line"></div>
      <div class="top" id="">
        <el-form-item label="盘点日期：" prop="dcountdate" class="tinp searchtime searchtime2" :class="{iconshow:showicon}">
          <el-date-picker value-format="yyyy-MM-dd" :picker-options="pickerOptions" v-model="list.dcountdate"
                          type="date" placeholder="选择日期" @mouseover.native="cleandataicon"
                          @mouseout.native="cleandataicon">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际盘点人：" prop="shipanname" class="tinp pan"
                      style="width: 262px;margin-left: 0px !important">
          <el-input v-model="list.shipanname" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable></el-input>
        </el-form-item>
        <el-form-item label="参与盘点人：" prop="canpanname" class="tinp pan" style="width: 262px;margin-left: 0px !important">
          <el-input v-model="list.canpanname" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable></el-input>
        </el-form-item>
        <el-form-item label="确认人：" prop="quepanname" class="tinp pan" style="width: 262px;margin-left: 0px !important">
          <el-input v-model="list.quepanname" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注：" class="tinp beizhuinp" style="width: 866px;margin-left: 0px !important">
          <el-input v-model="list.memo" placeholder="请输入内容" prefix-icon="el-icon-edit" clearable></el-input>
        </el-form-item>
        <el-form-item class="fr">
          <el-button size="small" type="primary" style="width:40px;height: 38px" icon="el-icon-plus"
                     @click="addList"></el-button>
        </el-form-item>
        <el-form-item class="fr">
          <el-button size="small" type="danger" style="width:40px;height: 38px" icon="el-icon-minus"
                     @click="delRow"></el-button>
        </el-form-item>
      </div>
      <!-- startprint -->
      <section ref="print">
        <div class="tablebox" style="margin: 0px;width:1156px">

          <!--  <table style="width:100%" class="pamdiantable">
             <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
               <th style="width:105px" v-for="head in tableHeads">{{ head.label }}</th>
             </tr>
             <tr v-for="(item,index) in list.productList" :id="'pro'+index" :class="{notTrue:item.isTure}"  v-if="count>=1" >
               <td  v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">

                 <el-input class="tabinp" v-model="item[head.key]" type="number" clearable @blur="counter(index,item.ncountnum)" v-if="head.key == 'ncountnum'"></el-input>
                 </el-input>
                 <el-input class="tabinp" v-model="item[head.key]" clearable v-else-if="head.key == 'vreason'"></el-input>
                 </el-input>
                 <el-input style="width: 100%" class="tabinp" v-else-if="item.addnum =='Y'&&head.key == 'materialname'" suffix-icon="el-icon-search" v-model="item.materialname" clearable v-on:click.native="selectProduct(index)">
                 </el-input>
                 <el-input v-else-if="item.addnum =='Y'&&head.key != 'materialname'" class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item[head.key]"></el-input>
                 <span v-else-if="item.addnum !='Y'" class="tabinp">{{item[head.key]}}</span>
               </td>
             </tr>
             <tr v-if="count ==0">
               <td colspan="10" style="border:1px solid rgba(239,240,244,1);background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
             </tr>
           </table> -->

          <!--  <table style="width:1156px;margin:0">
             <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
               <th class="tdwidth" style="width:105px">仓库</th>
               <th class="tdwidth" style="width:105px">货位</th>
               <th class="tdwidth" style="width:240px">商品名称</th>
               <th class="tdwidth" style="width:105px">商品编码</th>
               <th class="tdwidth" style="width:105px">规格</th>
               <th class="tdwidth" style="width:105px">型号</th>
               <th class="tdwidth" style="width:30px">单位</th>
               <th class="tdwidth" style="width:60px">盘点数量</th>
               <th class="tdwidth" style="width:300px">原因</th>
             </tr>
           </table> -->
          <div class="clearfix"  style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px;width:1156px;margin:0">
            <div class="fl" style="width:104px;height:45px;line-height: 45px;text-align:center;">仓库</div>
            <div class="fl" style="width:105px;height:45px;line-height: 45px;text-align:center;">货位</div>
            <div class="fl" style="width:240px;height:45px;line-height: 45px;text-align:center;">商品名称</div>
            <div class="fl" style="width:107px;height:45px;line-height: 45px;text-align:center;">商品编码</div>
            <div class="fl" style="width:105px;height:45px;line-height: 45px;text-align:center;">规格</div>
            <div class="fl" style="width:105px;height:45px;line-height: 45px;text-align:center;">型号</div>
            <div class="fl" style="width:33px;height:45px;line-height: 45px;text-align:center;">单位</div>
            <div class="fl" style="width:62px;height:45px;line-height: 45px;text-align:center;">盘点数量</div>
            <div class="fl" style="width:294px;height:45px;line-height: 45px;text-align:center;">原因</div>

          </div>
          <div id="prittableheight" style="overflow-y: auto;overflow-x:hidden;height: auto;width:1156px;max-height:654px">
            <table style="margin:0;width:1156px">
              <tr v-for="(item,index) in list.productList" :id="'pro'+index" :class="{notTrue:item.isTure}"  v-if="count>=1" >
                <td style="border: 1px solid #56B8AA; height: 38px;width:105px">
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.repertoryname}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.repertoryname"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:105px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.rackname}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.rackname"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:240px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.materialname}}</span>
                  <el-input v-else class="tabinp"suffix-icon="el-icon-search" v-model="item.materialname" clearable v-on:click.native="selectProduct(index)"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:105px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.materialcode}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.materialcode"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:105px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.wlspec}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.wlspec"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:105px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.wltype}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.wltype"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:30px" >
                  <span class="tabinp" v-if="item.addnum !='Y'">{{item.cunitname}}</span>
                  <el-input v-else class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item.cunitname"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:60px" >
                  <el-input class="tabinp" v-model="item.ncountnum" type="number" clearable @blur="counter(index,item.ncountnum)"></el-input>
                </td>
                <td style="border: 1px solid #56B8AA; height: 38px;width:300px" >
                  <el-input class="tabinp" v-model="item.vreason" clearable></el-input>
                </td>
                <!--  <td  v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
                   <el-input class="tabinp" v-model="item[head.key]" type="number" clearable @blur="counter(index,item.ncountnum)" v-if="head.key == 'ncountnum'"></el-input>
                   </el-input>
                   <el-input class="tabinp" v-model="item[head.key]" clearable v-else-if="head.key == 'vreason'"></el-input>
                   </el-input>
                   <el-input style="width: 100%" class="tabinp" v-else-if="item.addnum =='Y'&&head.key == 'materialname'" suffix-icon="el-icon-search" v-model="item.materialname" clearable v-on:click.native="selectProduct(index)">
                   </el-input>
                   <el-input v-else-if="item.addnum =='Y'&&head.key != 'materialname'" class="tabinp" v-on:click.native="chooseRow(index,'pro'+index)" v-model="item[head.key]"></el-input>
                   <span v-else-if="item.addnum !='Y'" class="tabinp">{{item[head.key]}}</span>
                 </td> -->
              </tr>
              <tr v-if="count ==0">
                <td colspan="10" style="border:1px solid rgba(239,240,244,1);background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
              </tr>
            </table>
          </div>

          <div class="prinbox fr">
          </div>
        </div>
      </section>
      <!-- endprint -->
    </el-form>
    <!-- model start -->
    <div class="model" v-show="modelShow2">
      <div class="content clearfix">
        <div class="title">
          <span class="fl">请选择商品</span>
          <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="procontent clearfix" style="padding: 0 20px">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="商品编码：" class="tinp">
              <el-input v-model="serchpro.productCode" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectprochange(index)"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" class="tinp">
              <el-input v-model="serchpro.productName" suffix-icon="el-icon-search" @keyup.enter.native="selectProduct(index)" clearable @change="selectprochange(index)"></el-input>
            </el-form-item>
            <el-button type="primary" class="" size="small" icon="el-icon-search" @click="selectProduct(index)">搜索</el-button>
          </el-form>
          <div class="productList" style="overflow-y: auto;overflow-x:hidden;width:100%;height: auto;max-height:332px">
            <table style="width:100%">
              <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                <th style="border: 1px solid #56B8AA;">选择</th>
                <th style="" v-for="head in proTitle">{{ head.label }}</th>
              </tr>
              <tr v-for="(item,index) in productList2" :id="index" :key="index">
                <td class="fir" style="color: #fff;border: 1px solid #56B8AA;">
                  <!-- <span style="color: #000;"> {{index}}</span> -->
                  <div class="list-item-check">
                    <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(index)">
                                        <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                    </span>
                  </div>
                </td>
                <td v-for="head in proTitle" style="border: 1px solid #56B8AA; height: 38px" @click="choose(index)">
                  {{item[head.key]}}
                </td>
              </tr>
            </table>
          </div>
          <el-button type="primary" class="fr" size="medium" style="margin-top: 16px" @click="checkpro">确定</el-button>
        </div>
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
                           :current-page="propage"
                           :page-size="prosize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="procount">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
      </div>
    </div>
    <!-- model start -->
    <!-- model end -->
    <!-- <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>  -->
    <!-- 弹窗 start -->
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag="butflag" @modelmsg="returnMsg"></MessageModel>
  </div>
</template>
<script>
  import Vue from 'vue';
  // import Print from 'print-js';
  export default {
    name: '',
    inject: ['reload'],
    data() {
      var validateDcountdate = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请选择盘点日期'));
        } else {
          callback();
        }
      };
      var validateShipanname = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请填写实际盘点人'));
        } else {
          callback();
        }
      };
      var validateCanpanname = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请填写参与盘点人'));
        } else {
          callback();
        }
      };
      var validateQuepanname = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请填写确认人'));
        } else {
          callback();
        }
      };
      return {
        flag: false,
        msgShow: false,
        modelFlag: false,
        modelFlag2: false,
        butflag: true,
        butflag2: true,
        msg: '',
        butmsg: '确认',
        butmsg2: '确认',
        methodName: '',
        utilpath: '',
        obj: {
          flag: true,
        },
        da:'',
        vueFlag:false,
        modelShow2: false,
        fullscreenLoading: false,
        InterfacePath: '',
        userInfo: {},
        showicon: '',
        propage:1,
        prosize:20,
        procount:0,
        positionflag:0,
        implist:[],
        serverTime:0,
        proTitle: [
          {
            label: '商品编码',
            key: 'materialcode'
          },
          {
            label: '商品名称',
            key: 'materialname'
          },
          {
            label: '规格',
            key: 'wlspec'
          },
          {
            label: '型号',
            key: 'wltype'
          },

          // {
          //     label: '单价',
          //     key: 'nprice'
          // },
          {
            label: '单位',
            key: 'cunitname'
          }
        ],
        positions:{
          positioncode: '',//货位编码
          positionname: ''//货位名称
        },
        serchpro:{
          storecode:'',
          productName:'',
          productCode:'',
        },
        productName:'',
        productCode:'',
        index:'',
        index2:'',
        delIndex:'',
        tableListindex:0,
        productList2:[],
        position: {
          positioncode: '',//货位编码
          positionname: ''//货位名称
        },
        count: 0,
        positionList: [],
        positionList2: [],
        positioncode: '',
        cloid: '',
        list: {
          corpcode:'',
          corpname:'',
          shipanname: '',
          canpanname: '',
          quepanname: '',
          countoperatorcode: '',
          countoperatorname: '',
          dcountdate: '',
          billmakercode: '',
          billmakername: '',
          storecode:'',
          storename:'',
          memo: '',
          productList: []
        },
        tijiaofalg: false,
        saveFalg: false,
        tableHeads: [
          {
            label: '仓库',
            key: 'repertoryname'
          },
          {
            label: '货位',
            key: 'rackname'
          },
          {
            label: '商品名称',
            key: 'materialname'
          },
          {
            label: '商品编码',
            key: 'materialcode'
          },
          {
            label: '规格',
            key: 'wlspec'
          },
          {
            label: '型号',
            key: 'wltype'
          },
          {
            label: '单位',
            key: 'cunitname'
          },
          {
            label: '* 盘点数量',
            key: 'ncountnum'
          },
          {
            label: '原因',
            key: 'vreason'
          }
        ],
        rules: {
          dcountdate: [
            { required: true, trigger: 'blur', validator: validateDcountdate }
          ],
          shipanname: [
            { required: true, trigger: 'blur', validator: validateShipanname }
          ],
          canpanname: [
            { required: true, trigger: 'blur', validator: validateCanpanname }
          ],
          quepanname: [
            { required: true, trigger: 'blur', validator: validateQuepanname }
          ]
        },
        pickerOptions: {
          disabledDate: (time) => {
            if(this.serverTime==0){
              this.serverTime = Date.now();
              this.$http.post(this.utilpath + '/getServerTime', null, {
                emulateJSON: true,
                _timeout: 600
              }).then((res) => {
                if (res.data.status == '0') {
                  this.serverTime = res.data.result;
                  console.info(res.data.result);
                } else if (res.data.status == '9') {
                  this.fullscreenLoading = false;
                  this.$router.push({path: '/ui/login', query: {msg: 9}});
                }
              }, (err) => {

              });
            }

            return time.getTime() < this.serverTime - 8.64e7 || time.getTime() > this.serverTime + 8.64e6
          }
        }
      }
    },

    destroyed() {
      // console.log("清除session");
      // window.localStorage.removeItem("prinlist");
      // window.localStorage.removeItem("listflg");
      // sessionStorage.removeItem("wei");
    },
    mounted() {

      var msg = this.$route.query.msg;
      if (msg == 0) {
        console.log("--------------跳转了！")
      }
      // 获取接口名
      this.InterfacePath = window.localStorage.getItem("InterfacePath");
      this.utilpath = this.axios.defaults.baseURL;
      this.init();
    },
    methods: {
      closemodel(){
        this.modelShow2 = false;
      },
      returnMsg2(flag) {

        this.modelFlag = false;

        if (flag) {
          //console.log("---进来了！！！----" + this.methodName);
          if (this.methodName == 'checkpro') {

          }else if(this.methodName == 'checkRow'){

          }else if(this.methodName == 'notNewRow'){

          }else if(this.methodName == 'checkprolist'){

          } else if(this.methodName == 'selectlist'){
            // this.reload();
          }
        }
      },
      returnMsg(flag) {
        this.modelFlag = false;
        if (flag) {
          //console.log("---进来了！！！----" + this.methodName);
          if(this.methodName == 'delRow'){
            this.fullscreenLoading=true;
            var param={
              pk_invcount:this.list.pk_invcount,
              pk_invcount_b:this.list.productList[this.delIndex].pk_invcount_b,
              storecode:this.userInfo.storecode
            }
            // console.log("---打印list：----" + JSON.stringify(this.list));
            //console.log("---打印删除参数：----" + JSON.stringify(param));
            this.$http.post(this.utilpath + '/deleteInvcountB', param, { emulateJSON: true,_timeout:600 }).then((res) => {
              this.fullscreenLoading=false;
              if (res.data.status == '0') {
                this.delIndex=''
                this.$message({
                  showClose: true,
                  message: '删除成功！',
                  type: 'succcess'
                });
                if(res.data.result!=null&&res.data.result!=''){
                  this.list = res.data.result;
                }
                this.list.productList = res.data.resultList;
                this.count = this.list.productList.length;
              } else if(res.data.status == '9'){
                this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
              } else{
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了';
              }
            }, (err) => {
              this.fullscreenLoading=false;
              this.msgShow =false;
              this.modelFlag = true;
              this.methodName = 'message';
              this.msg = '连接提交接口失败';
              this.butflag =false;
              this.butmsg='知道了';
            });
          }else if(this.methodName == 'delRow2'){
            this.list.productList.splice(this.delIndex, 1);
            this.count = this.list.productList.length;
          }else if(this.methodName == 'selectlist'){
            this.reload();
          }else if(this.methodName == 'repeatImport'){
            this.reload();
          }else if(this.methodName == 'inconf'){
            // this.reload();

            this.list.productList=this.implist;

            var _this=this;
            // setTimeout(function(){

            _this.reload();  //可以是一句或是很多句代码，也可以是个函数

            // },1000);　　　　//延时1秒
          }else if(this.methodName == 'messageim'){
            this.reload();
          }else if (this.methodName == 'save') {
            this.fullscreenLoading = true;
            this.list.positioncode = this.position.positioncode;
            this.list.positionname = this.position.positionname;
            var reqparam = {
              invcount: JSON.stringify(this.list),
            };
            // console.log("打印参数111" + JSON.stringify(reqparam));
            // console.log("打印参数111" + JSON.stringify(this.list));
            // console.log("打印参数111" + JSON.stringify(reqparam));
            this.$http.post(this.utilpath + '/insertInvcount', reqparam, { emulateJSON: true,_timeout:600 })
              // this.$http.post("/ktnapi/insertInvcount",reqparam,{emulateJSON:true})
              // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true})
              .then((res) => {
                // console.log("dayin===========post==="+JSON.stringify(res.data));
                if (res.data.status == '0') {
                  this.fullscreenLoading = false;
                  // this.list.productList = res.data.resultList;
                  // this.count = this.list.productList.length;
                  if(res.data.result!=null&&res.data.result!=''){
                    // this.list.pk_invcount =  res.data.result.pk_invcount;
                    // this.list.savenum =  res.data.result.savenum;
                    this.list = res.data.result;
                  }
                  // console.log("aaaaaaaaaaaaaa盘点的数据：-=-=-=" + JSON.stringify(this.list));
                  for (var i = 0; i < this.list.productList.length; i++) {
                    //console.log("查看盘点数量ncountnum：-=-=-=" + this.list.productList[i].ncountnum+"nonhandnum----"+this.list.productList[i].nonhandnum);
                    if (this.list.productList[i].ncountnum - this.list.productList[i].nonhandnum> 0) {
                      document.getElementById('pro'+i).style.color = "#56B8AA";
                      // console.log("打印判断值" + this.list.productList[i].isTure);
                    }else if(this.list.productList[i].ncountnum - this.list.productList[i].nonhandnum< 0){
                      document.getElementById('pro'+i).style.color = "#F56C6C";
                    } else {
                      document.getElementById('pro'+i).style.color = "#333";
                    }
                  }
                  this.$message({
                    showClose: true,
                    message: '保存成功！',
                    type: 'succcess'
                  });
                  sessionStorage.setItem("prinlist", JSON.stringify(this.list.productList));
                } else if(res.data.status == '9'){
                  this.fullscreenLoading =false;
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                } else {
                  this.fullscreenLoading = false;
                  this.modelFlag = true;
                  this.msgShow = true;
                  this.methodName = 'message';
                  this.msg = res.data.message;
                  this.butflag =false;
                  this.butmsg='知道了';
                }
              }, (err) => {
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow =false;
                this.methodName = 'message';
                this.msg = '连接保存盘点单接口失败'+err;
                this.butflag =false;
                this.butmsg='知道了';
              });
          } else if (this.methodName == 'submit') {
            this.fullscreenLoading = true;
            this.list.positioncode = this.position.positioncode;
            this.list.positionname = this.position.positionname;
            var reqparam = {
              invcount: JSON.stringify(this.list), //
              storecode: this.userInfo.storecode,
              positioncode: this.position.positioncode, //货位
              positionname: this.position.positionname, //货位
            };
            this.$http.post(this.utilpath + '/sendInvcount', reqparam, { emulateJSON: true,_timeout:600 })
              // this.$http.post("/ktnapi/insertInvcount",reqparam,{emulateJSON:true})
              // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true})
              .then((res) => {
                //console.log("0000dayin===========post==="+JSON.stringify(res.data));
                if (res.data.status == '0') {
                  this.fullscreenLoading = false;
                  this.$message({
                    showClose: true,
                    message: '提交成功！',
                    type: 'succcess'
                  });
                  this.list.shipanname = '';
                  this.list.canpanname = '';
                  this.list.quepanname = '';
                  this.list.dcountdate = '';
                  this.list.savenum = '0';
                  this.list.productList = res.data.resultList;
                  this.count = this.list.productList.length;
                  for (var i = 0; i < this.list.productList.length; i++) {

                    document.getElementById('pro'+i).style.color = "#263238";
                  }
                  //console.log("盘点的数据：-=-=-=" + JSON.stringify(this.list));
                  sessionStorage.setItem("prinlist", JSON.stringify(this.list.productList));

                } else if(res.data.status == '9'){
                  this.fullscreenLoading =false;
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                } else {
                  this.fullscreenLoading = false;
                  this.modelFlag = true;
                  this.msgShow = true;
                  this.methodName = 'message';
                  this.msg = res.data.message;
                  this.butflag =false;
                  this.butmsg='知道了';
                }
              }, (err) => {
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow =false;
                this.methodName = 'message';
                this.msg = '连接提交接口失败'+err;
                this.butflag =false;
                this.butmsg='知道了';
              });
          }
        } else {
          this.fullscreenLoading = false;
          this.$message({
            showClose: true,
            message: '已取消',
            type: 'succcess'
          })
        }
      },
      addList() {
        if(this.position.positioncode != '01'){
          this.$message({
            showClose: true,
            message: '零号仓位能新增商品，请检查盘点货位！',
            type: 'error'
          })
          return;
        }
        //console.log("打印用户仓库："+this.userInfo.storehouse_name.replace(/^\s+|\s+$/g,""))
        var pro ={
          checked:'0',
          addnum:'Y',
          repertorycode:this.userInfo.storehouse_code,
          repertoryname:this.userInfo.storehouse_name.replace(/^\s+|\s+$/g,""),
          rackcode :this.position.positioncode,
          rackname :this.position.positionname.replace(/^\s+|\s+$/g,""),
          materialcode :'',
          materialname :'',
          wlspec:'',
          wltype:'',
          cunitname:'',
          ncountnum:'',
          nonhandnum:0,
          ndiffnum:'',
          vreason:'',
        }
        this.list.productList.push(pro);
        // this.selectProduct(this);
      },
      numdown(num){
        //console.log("进来判断了");
        if(num<0){
          this.$message({
            showClose: true,
            message: '盘点数量不能为负数！',
            type: 'error'
          });
        }
      },
      choose(index){
        this.productList2[index].checked= this.productList2[index].checked=='1'?'0':'1';
        for(var i=0;i<this.productList2.length;i++){
          if(i!=index){
            this.productList2[i].checked='0'
            document.getElementById(i).style.backgroundColor="#fff"
          }
        }
        if(this.productList2[index].checked=='1'){

          document.getElementById(index).style.backgroundColor="#FFEFB7"
        }else{

          document.getElementById(index).style.backgroundColor="#fff"
        }
        this.index2=index;
        //console.log("1_=-=-=-=-="+this.index+"-=-=-=-=-=-w"+this.index2+"w-=-=-"+index+"=-=-=-=000"+this.productList2[this.index2].checked+"000-=-=-=-=-=-");
      },
      delRow() {
        if(this.position.positioncode != '01'){
          this.$message({
            showClose: true,
            message: '零号仓位能删除商品，请检查盘点货位！',
            type: 'error'
          })
          return;
        }
        if (this.delIndex != '') {
          if (this.vueFlag) {
            this.methodName = 'delRow2';
            this.modelFlag = true;
            this.msgShow =false;
            this.butflag =true;
            this.butmsg='确定';
            this.msg = '确定删除刚刚新增的行？'
          }else if(this.list.productList[this.delIndex].addnum !=undefined&&this.list.productList[this.delIndex].addnum =='Y'){
            this.methodName = 'delRow';
            this.modelFlag = true;
            this.msgShow =false;
            this.butflag =true;
            this.butmsg='确定';
            this.msg = '此操作将删除该行，是否继续？'
          }else{
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'notNewRow';
            this.msg = '该行不是新增行，不能删除！';
            this.butflag =false;
            this.butmsg='知道了';
          }
        }else{
          this.modelFlag = true;
          this.methodName = 'checkRow';
          this.msgShow =false;
          this.msg = '请选中删除的行！';
          this.butflag =false;
          this.butmsg='知道了';

        }

      },
      chooseRow(index,procode){
        this.vueFlag = true;
        //console.log("点击-----下标"+index+"-----------商品编码:"+procode);
        this.delIndex = index;
        this.list.productList[index].checked= this.list.productList[index].checked=='1'?'0':'1';
        for(var i=0;i<this.list.productList.length;i++){
          if(i!=index){
            this.list.productList[i].checked='0'
            document.getElementById('pro'+i).style.backgroundColor="#fff"
          }
        }
        // if(this.list.productList[index].checked=='1'){

        document.getElementById(procode).style.backgroundColor="#FFEFB7"
        // }else{

        // document.getElementById(procode).style.backgroundColor="#fff"
        // }
      },
      selectImportNum(obj){

        var reqParam ={
          storecode:this.userInfo.storecode,//门店编码
          positioncode: this.position.positioncode, //货位
          positionname: this.position.positionname, //货位
          dcountdate:this.list.dcountdate//盘点日期
        };
        this.$http.post(this.utilpath + '/selectImportNum', reqParam, { emulateJSON: true,_timeout:600 }).then((result) => {
          var res = result.data;
          if (res.status == '0') {
            //可以导入

            window.localStorage.setItem("prinlist", JSON.stringify(this.list.productList));
            // this.insertImportNum();
          } else if (res.status == '-1') {
            //不可以导入
            this.list.productList=this.implist;
            //可以导入

            window.localStorage.setItem("prinlist", JSON.stringify(this.list.productList));

            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'repeatImport';
            this.msg = '每个货位只能导入一次，不可重复导入！';
            this.butflag =false;
            this.butmsg='知道了';
          } else if(res.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else {
            window.localStorage.removeItem("panwei");
            window.localStorage.removeItem("prinlist");
            window.localStorage.removeItem("listflg");
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'messageim';
            this.msg = res.message;
            this.butflag =false;
            this.butmsg='知道了';
          }
        }, (err) => {
          window.localStorage.removeItem("panwei");
          window.localStorage.removeItem("prinlist");
          window.localStorage.removeItem("listflg");
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'messageim';
          this.msg = '调用查询导入次数失败';
          this.butflag =false;
          this.butmsg='知道了';
        });
      },
      importf(obj) {
        if(this.list.productList.length==0){
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'selectlist';
          this.msg = '请先查询库存的商品再导入！';
          this.butflag =false;
          this.butmsg='知道了';
          return;
        }
        else{
          let _this = this;

          this.file = event.currentTarget.files[0];

          var f = this.file;

          var reader = new FileReader();


          reader.onload = function(e) {
            // var binary = "";

            var wb; //读取完成的数据

            var outdata;

            var XLSX = require('xlsx');

              wb = XLSX.read(e.target.result, {

                type: 'binary'

              });

            // outdata就是你想要的东西 excel导入的数据

            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);

            // excel 数据再处理

            let arr = []
            // var prolist=[];
            outdata.map(v => {

              let obj = {}

              obj.repertorycode = _this.userInfo.storehouse_code;
              obj.repertoryname = v.仓库
              obj.rackname = v.货位
              obj.rackcode = _this.position.positioncode;

              _this.judgePosition(v.仓库, v.货位);
              obj.materialname = v.商品名称

              obj.materialcode = v.商品编码
              if (v.规格) {
                obj.wlspec = v.规格
              } else {
                obj.wlspec = null
              }
              if (v.规格) {
                obj.wltype = v.型号
              } else {
                obj.wltype = null
              }

              obj.cunitname = v.单位

              obj.ncountnum = v.盘点数量.toString()

              if (v.原因) {
                obj.vreason = String(v.原因)
              } else {
                obj.vreason = null
              }
              // console.log('chang：'+_this.list.productList.length)
              for (var j = 0; j < _this.list.productList.length; j++) {
                // console.log('小循环里面：'+_this.list.productList[j].materialcode+' -----外面：'+prolist[i].materialcode)
                if (_this.list.productList[j].materialcode == obj.materialcode) {
                  // console.log('相等') String(number)
                  obj.cunitcode = String(_this.list.productList[j].cunitcode);
                  if (typeof (_this.list.productList[j].nonhandnum) === "number") {
                    obj.nonhandnum = _this.list.productList[j].nonhandnum.toString();
                    obj.ndiffnum = (_this.list.productList[j].ncountnum - _this.list.productList[j].nonhandnum).toString();
                  } else {
                    obj.nonhandnum = _this.list.productList[j].nonhandnum;
                    obj.ndiffnum = (_this.list.productList[j].ncountnum - _this.list.productList[j].nonhandnum).toString();
                  }
                  obj.checked = _this.list.productList[j].checked;
                  obj.addnum = _this.list.productList[j].addnum;

                  break;
                } else {
                  obj.nonhandnum = "0";
                  obj.ndiffnum = obj.ncountnum;
                  obj.cunitcode = null;
                  // console.log('不相等')
                }
              }

              arr.push(obj)

            })
            var prolist = [...arr];
            if (_this.positionflag == 1) {
              _this.list.productList = prolist;
              _this.count = _this.list.productList.length
              // console.log('-----'+JSON.stringify(_this.list));


              var listflg = {
                checked: '0',
              }
              var pra = {
                dcountdate: _this.list.dcountdate,
                shipanname: _this.list.shipanname,
                canpanname: _this.list.canpanname,
                quepanname: _this.list.quepanname,
                memo: _this.list.memo
              }
              window.localStorage.setItem("panwei", JSON.stringify(_this.position));
              window.localStorage.setItem("listflg", JSON.stringify(listflg));
              window.localStorage.setItem("titlemsg", JSON.stringify(pra));

              // _this.reload();


              // var test =JSON.parse(window.localStorage.getItem("listflg"));
              window.localStorage.setItem("prinlist", JSON.stringify(_this.list.productList));
              // _this.selectImportNum();
              // _this.modelFlag = true;
              // _this.msgShow =false;
              // _this.methodName = 'inconf';
              // _this.msg = '上传完成！';
              // _this.butflag =false;
              // _this.butmsg='好的';
            }
          }
          reader.readAsBinaryString(f);
          document.getElementById("uploadFile").value="";
        }
      },
      judgePosition(t1,t2){
        var test1=this.userInfo.storehouse_name;
        var test2=this.position.positionname;
        console.log(test1+"-----"+test2)
        if(t1==test1&&t2==test2){
          this.positionflag=1;
        }else{
          this.list.productList=this.implist;
          var listflg ={
            checked:'0',
          }
          window.localStorage.setItem("prinlist", JSON.stringify(this.implist));
          window.localStorage.setItem("panwei", JSON.stringify(this.position));
          window.localStorage.setItem("listflg", JSON.stringify(listflg));
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'inconf';
          this.msg = '当前页的仓库或货位与导入的数据不一致！';
          this.butflag =false;
          this.butmsg='知道了';
        }
      },
      insertImportNum(){
        var reqParam ={
          storecode:this.userInfo.storecode,//门店编码
          positioncode: this.position.positioncode, //货位
          positionname: this.position.positionname, //货位
          dcountdate:this.list.dcountdate//盘点日期
        };
        this.$http.post(this.utilpath + '/insertImportNum', reqParam, { emulateJSON: true,_timeout:600 }).then((result) => {
          var res = result.data;
          if (res.status == '0') {
            this.reload();
          } else if(res.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'messageim';
            this.msg = res.message;
            this.butflag =false;
            this.butmsg='知道了';
          }
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'messageim';
          this.msg = '记录导入次数失败';
          this.butflag =false;
          this.butmsg='知道了';
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      exportPresentSock3() {
        var len=this.count;
        if(len<1){
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'checkprolist';
          this.msg = '请先查询出库存商品再导出！';
          this.butflag =false;
          this.butmsg='知道了';

        }else{
          require.ensure([], () => {
            var { export_json_to_excel } = require('../../vendor/Export2Excel');
            var tHeader2 = ['仓库', '货位', '商品名称', '商品编码', '规格', '型号', '单位', '盘点数量', '原因'];
            var filterVal2 = ['repertoryname','rackname','materialname', 'materialcode', 'wlspec', 'wltype','cunitname', 'ncountnum', 'vreason'];
            var list2 = JSON.parse(JSON.stringify(this.list.productList));
            var data2 = this.formatJson(filterVal2, list2);
            export_json_to_excel(tHeader2, data2, '盘点单');
          })
        }
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      checkpro(){
        // console.log("1_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-=000"+this.productList2[this.index2].checked+"000-=-=-=-=-=-");
        var flag = false;
        var numindex = '';
        if(this.productList2[this.index2].checked=='1'){
          // console.log("2_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-=000"+this.productList2[this.index2].checked+"000-=-=-=-=-=-");
          for(var i=0;i<this.list.productList.length;i++){

            if(this.list.productList[i].materialname == this.productList2[this.index2].materialname){
              numindex = i;
              flag = true;
            };
          };
          if(flag){
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'checkpro';
            this.msg = '该商品已存在！';
            this.butflag =false;
            this.butmsg='知道了';
          }else{
            // console.log("4_=-=-=-=-="+this.index+"-=-=-=-=-=-"+this.index2+"-=-=--=-=-=-="+this.productList2[this.index2].checked);
            this.list.productList[this.index].materialname = this.productList2[this.index2].materialname;
            this.list.productList[this.index].materialcode = this.productList2[this.index2].materialcode;
            this.list.productList[this.index].wlspec = this.productList2[this.index2].wlspec;
            this.list.productList[this.index].wltype = this.productList2[this.index2].wltype;
            this.list.productList[this.index].cunitcode = this.productList2[this.index2].measdoccode;
            this.list.productList[this.index].cunitname = this.productList2[this.index2].measdocname;
            // this.list.productList[this.index].nprice = this.productList2[this.index2].nprice;
            // this.list.productList[this.index].ntaxmny = this.productList2[this.index2].nprice;
            // this.list.productList[this.index].ntaxmny = this.productList2[this.index2].nprice;
            // this.list.productList[this.index].ntaxratecode = this.productList2[this.index2].taxratecode;
            // this.list.productList[this.index].ntaxratevalue = this.productList2[this.index2].taxratename;
            this.productList2[this.index2].checked = '0';
          }
          this.productList2[this.index2].checked = '0';
          this.modelShow2 = false;
        }else{
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '请至少选择一件商品';
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert('请至少选择一件商品', '警告', {
          //        confirmButtonText: '确定'
          //  });
        }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.prosize = val;
        this.propage=1;
        this.selectProduct();
        //console.log(this.prosize);
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.propage = val;
        //console.log(this.propage);
        this.selectProduct(this.index);
      },
      selectprochange(num){
        this.propage=1;
        this.selectProduct(num);
      },
      selectProduct(num) {
        this.index = num == null ? this.index : num;
        this.modelShow2 = true;
        var reqParam ={
          storecode:this.userInfo.storecode,
          productName:this.serchpro.productName,
          productCode:this.serchpro.productCode,
          pageNum:this.propage,
          pageSize:this.prosize,
        };
        this.$http.post(this.utilpath + '/selectAllProductList', reqParam, { emulateJSON: true,_timeout:600 }).then((result) => {
          // this.$http.post("/ktnapi/selectPresentSockForProduct",this.serchpro,{emulateJSON:true}).then((result) => {
          // this.$http.post(this.InterfacePath+"/selectAllSpdirectory",this.serchpro,{emulateJSON:true}).then((result) => {
          var res = result.data;
          if (res.status == '0') {
            this.productList2 = res.resultList;
            this.productName = this.serchpro.productName;
            this.productCode = this.serchpro.productCode;
            if (this.serchpro.productName != '' || this.serchpro.productName != null||this.serchpro.productCode != '' || this.serchpro.productCode != null) {

              sessionStorage.setItem("productList2", JSON.stringify(this.productList2));
            }
            // console.log("_+_+初始化打印商品信息_+_+_" + JSON.stringify(this.productList2));
            this.procount=res.countNum;
          } else if (res.status == '-1') {
            //console.log("-----暂无数据！！！");
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.message;
            this.butflag =false;
            this.butmsg='知道了';
          }
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '调用查询商品目录接口失败';
          this.butflag =false;
          this.butmsg='知道了';
        });
      },
      exportPan() {
        this.fullscreenLoading = true;
        //搜索参数
        var reqparam = {
          invcount: this.list, //盘点单
        };
        this.$http.post(this.utilpath + '/exportInvcount', reqparam, { emulateJSSON: true,_timeout:600 })
          // this.$http.post("/ktnapi/exportInvcount",reqparam,{emulateJSSON:true})
          // this.$http.post(this.InterfacePath+"/exportInvcount",reqparam,{emulateJSON:true})
          .then((res) => {
            if (res.data.status == '0') {
              this.fullscreenLoading = false;
              this.$message({
                showClose: true,
                message: '导出成功',
                type: 'succcess'
              });
              //console.log("盘点的数据：-=-=-=" + JSON.stringify(this.list));
            } else if(res.data.status == '9'){
              this.$router.push({path:'/ui/login',query:{msg:9}});
            } else {
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了';
            }
            // console.log("获取数据长度："+this.list.productList.length);
            //console.log("获取数据："+JSON.stringify(this.list.productList.productList));
            // console.log("获取的JSON数据"+JSON.stringify(res.result));
          }, (err) => {
            console.log(err);
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = res.message;
            this.butflag =false;
            this.butmsg='知道了';
          });
      },
      selectchange(value) {
        //console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
        this.position.positioncode = value.positioncode;
        this.position.positionname = value.positionname;
        sessionStorage.setItem("wei", JSON.stringify(this.position));
        this.modelShow = false;
        // this.getList();
      },
      getposition() {
        //获取数据接口 storecode:this.userInfo.storecode,
        var reqParam = {
          storecode: this.userInfo.storecode
        };
        this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
          // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
          // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
          if (res.data.status == '0') {
            var positions = res.data.resultList;
            //var positions=res.data.result;
            this.positionList = [];
            for (var i = positions.length - 1; i > -1; i--) {
              if(positions[i].memo==0||positions[i].memo==1){
                continue;
              }
              this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
            }
            //console.log("打印货位" + JSON.stringify(this.positionList));
          } else if (res.data.status == '-1') {
            this.positionList = [];
            this.$message({
              showClose: true,
              message: '暂无货位数据',
              type: 'info',
            });
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
          }
          // console.log("获取的JSON数据"+JSON.stringify(res.result));
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '获取货位接口失败'+err;
          this.butflag =false;
          this.butmsg='知道了';
        });
      },
      getpositions() {
        //获取数据接口
        var reqParam = {
          storecode: this.userInfo.storecode,
          flag: '0'
        };
        //console.log("111打印参数storecode" + reqParam.storecode);
        // this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
          // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
          // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
          if (res.data.status == '0') {
            //console.log();
            var positions = res.data.resultList;
            if (positions[0].memo != 0 && positions[0].memo != 1) {
              this.position.positioncode = positions[0].positioncode;
              this.position.positionname = positions[0].positionname;
            }

            //console.log("111打印货位position" + JSON.stringify(this.position));
            // this.getList();

          } else if (res.data.status == '-1') {
            this.position.positioncode = '';
            this.position.positionname = '';
            this.$message({
              showClose: true,
              message:'暂无数据',
              type: 'info'
            });
          } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
            // this.$alert(res.data.message + '+else状态：' + res.data.status, '失败信息', {
            //   confirmButtonText: '确定'
            // });
          }
          // console.log("获取的JSON数据"+JSON.stringify(res.result));
        }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '获取货位接口失败'+err;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert('获取货位接口失败' + err, '失败信息', {
          //   confirmButtonText: '确定'
          // });
          console.log(err);
        });
      },
      getList() { //获取数据
        if(this.list.dcountdate==null ||this.list.dcountdate=='' ){
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '请先选择盘点日期再查询！';
          this.butflag =false;
          this.butmsg='知道了';

        }else{
          this.fullscreenLoading = true;
          //搜索参数
          var reqparam = {
            storecode: this.userInfo.storecode, //门店编码
            positioncode: this.position.positioncode, //货位
            positionname: this.position.positionname, //货位
            flag:0,
          };
          //console.log("reqpara-=-==m" + JSON.stringify(reqparam));
          this.$http.post(this.utilpath + '/selectPresentSock', reqparam, { emulateJSON: true,_timeout:600 })
            // this.$http.post("/ktnapi/selectPresentSock",reqparam,{emulateJSON:true})
            // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true})
            .then((res) => {
              //console.log("是否进来？"+JSON.stringify(res.data));
              if (res.data.status == '0') {
                this.fullscreenLoading = false;
                if(res.data.result!=null&&res.data.result!=''){
                  // this.list.savenum =  res.data.result.savenum;
                  // this.list.shipanname = res.data.result.shipanname;
                  // this.list.canpanname = res.data.result.canpanname;
                  // this.list.quepanname = res.data.result.quepanname;
                  // this.list.countoperatorcode = res.data.result.countoperatorcode;
                  // this.list.countoperatorname = res.data.result.countoperatorname;
                  // this.list.dcountdate = res.data.result.dcountdate;
                  this.list = res.data.result;
                }
                this.list.productList = res.data.resultList;
                this.implist = res.data.resultList;
                this.count = this.list.productList.length;
                // sessionStorage.removeItem("kucunlist");
                var pra={
                  dcountdate:this.list.dcountdate,
                  shipanname:this.list.shipanname,
                  canpanname:this.list.canpanname,
                  quepanname:this.list.quepanname,
                  memo:this.list.memo
                }
                window.localStorage.setItem("titlemsg",JSON.stringify(pra));
                window.localStorage.setItem("implist",JSON.stringify(this.implist));
                //console.log("查询数据盘点1111" + JSON.stringify(this.list));
                // console.log("session数据"+sessionStorage.getItem("kucunlist"));
                this.count = this.list.productList.length;
                // console.log("打印数据长度：" + this.count);
                // console.log("ListLenfth" + this.list.productList.length);
                // console.log("查看盘点数量ncountnum：-=-=-=" + this.list.productList[0].ncountnum+"nonhandnum----"+this.list.productList[0].nonhandnum);
                // for (var i = 0; i < this.list.productList.length; i++) {
                //  console.log("查看盘点数量ncountnum：-=-=-=" + this.list.productList[i].ncountnum-this.list.productList[i].nonhandnum+"nonhandnum----"+this.list.productList[i].nonhandnum);
                //           if (parseInt(this.list.productList[i].ncountnum) - parseInt(this.list.productList[i].nonhandnum)> 0) {
                //             document.getElementById('pro'+i).style.color = "#56B8AA";
                //             console.log("打印判断值" + this.list.productList[i].isTure);
                //           }else if(parseInt(this.list.productList[i].ncountnum) - parseInt(this.list.productList[i].nonhandnum)< 0){
                //             document.getElementById('pro'+i).style.color = "#F56C6C";
                //           } else {
                //             document.getElementById('pro'+i).style.color = "#333";
                //           }
                // }
              } else if (res.data.status == '-1') {
                this.fullscreenLoading = false;
                this.list.productList = [];
                this.$message({
                  showClose:true,
                  message:'暂无数据！',
                  type:'info'
                });
                // this.modelFlag = true;
                // this.methodName = 'message';
                // this.msg = res.data.message;
                // this.butflag2 =false;
                // this.butmsg2='知道了';
                // this.$alert("无数据" + res.data.message, '失败信息', {
                //   confirmButtonText: '确定'
                // });
              } else if(res.data.status == '9'){
                // this.$router.push({path:'/ui/login',query:{msg:9}});
                this.fullscreenLoading = false;
                this.count =1;
              } else {
                this.count = 0;
                this.list.productList = []
                //console.log("-=-=-=-" + JSON.stringify(res.data));
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了';
                // this.$alert(res.data.message, '失败信息', {
                //   confirmButtonText: '确定'
                // });
              }

            }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取盘点数据失败!'+err;
              this.butflag =false;
              this.butmsg='知道了';
              // this.$alert("是哪里连接失败" + res.data.message, '失败信息', {
              //   confirmButtonText: '确定'
              // });
            });
        }
      },
      init() {
        var titlemsg = JSON.parse(window.localStorage.getItem("titlemsg"));
        var proimlist = JSON.parse(window.localStorage.getItem("implist"));
        var list = JSON.parse(window.localStorage.getItem("prinlist"));
        var panwei = JSON.parse(window.localStorage.getItem("panwei"));
        var users = JSON.parse(window.localStorage.getItem("userInfo"));
        var listflg = JSON.parse(window.localStorage.getItem("listflg"));;
        if (users != null) {
          this.userInfo = users;
          this.getposition();
          this.list.corpcode = this.userInfo.corpcode;
          this.list.corpname = this.userInfo.corpname;
          this.list.storecode = this.userInfo.storecode;
          this.list.storename = this.userInfo.storename;
          this.list.countoperatorcode = this.userInfo.user_code;
          this.list.countoperatorname = this.userInfo.user_name;
          this.list.repertorycode = this.userInfo.storehouse_code;
          this.list.repertoryname = this.userInfo.storehouse_name;
        }

        if(proimlist){
          this.implist=proimlist
        }
        if(titlemsg){
          this.list.dcountdate=titlemsg.dcountdate;
          this.list.shipanname=titlemsg.shipanname;
          this.list.canpanname=titlemsg.canpanname;
          this.list.quepanname=titlemsg.quepanname;
          this.list.memo=titlemsg.memo;
        }
        // console.log('标识符 :'+JSON.stringify(listflg))

        if(listflg !=null && listflg.checked=='0'){
          this.list.productList=list
          this.count = this.list.productList.length;
        }
        console.log('长度 :'+this.count);
        console.log('集合 :'+JSON.stringify(list));
        if(panwei ==null){

          this.getpositions();
        }else{
          this.position.positioncode=panwei.positioncode;
          this.position.positionname=panwei.positionname;
        }

      },

      getList0() {
        // console.log("this.position.positioncode" + this.position.positioncode);
        //搜索参数
        var reqparam = {
          storecode: this.userInfo.storecode, //门店编码
          // positioncode:reqPa.positioncode,
          // positionname:reqPa.positionname
        };
        // console.log("getList参数reqparam" + JSON.stringify(reqparam));
        this.$http.post(this.utilpath + '/PositionToPresentSock', reqparam, { emulateJSON: true,_timeout:600 })
          // this.$http.post("/ktnapi/PositionToPresentSock",reqparam,{emulateJSON:true})
          // this.$post("/selectPresentSock",reqparam,{emulateJSON:true})
          // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true})

          .then((res) => {
            if (res.data.status == '0') {
              this.list.productList = res.data.resultList;
              this.count = this.list.productList.length;
              this.position.positioncode = this.list.productList[0].positioncode;
              this.position.positionname = this.list.productList[0].positionname;
              // console.log("盘点的数据position：-=-=-=" + JSON.stringify(this.position));
              // console.log("盘点的数据：-=-=-=" + JSON.stringify(this.list));
              sessionStorage.setItem("prinlist", JSON.stringify(this.list.productList));
            } else if (res.data.status == '-1') {
              this.count = 0;
              this.$message({
                showClose: true,
                message: '暂无数据',
                type: 'info'
              });
            } else if(res.data.status == '9'){
              this.$router.push({path:'/ui/login',query:{msg:9}});
            } else {
              // console.log("-=-=-=-" + JSON.stringify(res.data));
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了';
              // this.$alert("是哪里" + res.data.message, '失败信息', {
              //   confirmButtonText: '确定'
              // });
            }
            // console.log("获取数据长度："+this.list.productList.length);
            //console.log("获取数据："+JSON.stringify(this.list.productList.productList));
            // console.log("获取的JSON数据"+JSON.stringify(res.result));
          }, (err) => {
            console.log(err);
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = "连接获取现存量数据接口失败：" + err;
            this.butflag =false;
            this.butmsg='知道了';
            // this.$alert("连接获取现存量数据接口失败：" + err, '失败信息', {
            //   confirmButtonText: '确定'
            // });
          });
      },
      print2() {
        var idmsg="prittableheight";
        // console.log("打印框---"+document.getElementById(idmsg).style);
        document.getElementById(idmsg).style.maxHeight='100%'
        this.$print(this.$refs.print) // 使用
        document.getElementById(idmsg).style.maxHeight= '440px';
      },

      print() { //连接打印方法
        var idmsg="prittableheight";
        //console.log("打印框---"+document.getElementById(idmsg).style);
        document.getElementById(idmsg).style.maxHeight='100%'
        sessionStorage.setItem("wei", this.position);
        sessionStorage.setItem("prinlist", JSON.stringify(this.list));
        this.obj.flag = false;
        console.log(this.obj.flag);
        // this.$set(this.obj, 'flag', false);
        // console.log(this.obj.flag);
        // this.$forceUpdate();
        var positionname = this.cloid;
        // 1.保存原始html并设置要打印的区域
        var oldstr = document.body.innerHTML;
        var newstr = document.getElementsByClassName('tablebox')[0].innerHTML;
        // 2. 复制给body，并执行window.print打印功能
        document.body.innerHTML = newstr;
        // 3.打印
        window.print();
        // 4.重新加载页面，以刷新数据
        document.body.innerHTML = oldstr;
        window.location.reload();
        // document.getElementsById('prittableheight').style.max-height='100%';
        // this.$router.push({ path: '/ui/stock/pandi2/zengpan'});
        // this.reload();
      },
      counter(index,num) { //实时计算差异数量
        // console.log("index:" + index);
        var ncountnum = this.list.productList[index].ncountnum;
        if (ncountnum == '') {
          ncountnum = 0;
        }
        var num = (parseInt(ncountnum - this.list.productList[index].nonhandnum)) + '';
        this.list.productList[index].ndiffnum = num;
        Vue.set(this.list.productList, index, this.list.productList[index]);
        sessionStorage.setItem("prinlist", JSON.stringify(this.list.productList));
        //console.log("打印盘点数："+ncountnum);
        if(ncountnum<0){
          this.$message({
            showClose: true,
            message: '盘点数量不能为负数！',
            type: 'error'
          });
        }
      },
      cleandataicon() {
        // console.log("打印时间-=-=-=-"+this.list.dcountdate);
        if (this.time != '') {
          // console.log("打印时间-=-=-=-"+this.list.dcountdate);
          this.showicon = !this.showicon;
        }
        if (this.time == null) {
          this.showicon = false;
        }
      },
      tijiao() {
        this.savejudge();
        this.tijiaofalg = false;
        var baocun = false;
        if (this.saveFalg) {
          this.$confirm('部分商品实盘数量与库存不匹配, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //console.log("-----------then------------YES")
            this.tijiaofalg = true;

          }).catch(() => {
            //console.log("-----------catch------------YES")
            baocun = true;
          });
        } else {
          //console.log("-----------else------------YES")
          this.zuizhongtijiao();
        }

        // if(this.tijiaofalg){
        // }
        if (baocun) {
          //console.log("-----------baocun------------YES")
          this.savejudge();
        }
        this.zuizhongtijiao();
      },
      zuizhongtijiao() {
        if (this.tijiaofalg) {
          // console.log("dayin===========zuizhongtijiao===");
          //搜索参数
          var reqparam = {
            invcount: JSON.Stringify(this.list), //
            storecode: this.userInfo.storecode,
            pageNum: this.page,
            pageSize: this.pageSize,
          };
          this.$http.post(this.utilpath + '/insertInvcount', reqparam, { emulateJSON: true,_timeout:600})
            // this.$http.post("/ktnapi/insertInvcount",reqparam,{emulateJSON:true})
            // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true})
            .then((res) => {
              // console.log("dayin===========post===");
              if (res.data.status == '0') {
                this.$message({
                  showClose: true,
                  message: '提交成功！',
                  type: 'succcess'
                });
                this.list.productList = res.data.resultList;
                this.count = this.list.productList.length;
                // console.log("盘点的数据：-=-=-=" + JSON.stringify(this.list));
                sessionStorage.setItem("prinlist", JSON.stringify(this.list.productList));
              } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
              } else {
                this.fullscreenLoading = false;
                this.$alert(res.data.message, '失败信息', {
                  confirmButtonText: '确定'
                });
              }
            }, (err) => {
              console.log(err);
              this.$alert("连接提交接口失败：" + err, '失败信息', {
                confirmButtonText: '确定'
              });
            });
        }
      },
      savejudge() {

        for (var i = 0; i < this.list.productList.length; i++) {
          if (this.list.productList[i].nonhandnum - this.list.productList[i].ncountnum != 0) {
            this.saveFalg = true;
            // this.list.productList[i].isTure = true;
            document.getElementById(i).style.color = "#F56C6C";
            // console.log("打印判断值" + this.list.productList[i].isTure);
          } else {
            document.getElementById(i).style.color = "#333";
          }
        }
      },
      saveForm(formName) {
        // this.fullscreenLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var flag = true;
            var flag2 = false;
            this.list.productList.forEach((item) => {
              if (item.ncountnum === ''||item.ncountnum ===null) {
                //console.log("index:" + JSON.stringify(item));
                flag = false;
                return;
              };
              if(item.ncountnum<0){
                flag2 =true;
              }
            });
            if (flag&&!flag2) {
              this.methodName = 'save';
              this.modelFlag = true;
              this.msgShow =false;
              this.butflag = true;
              this.butmsg='确认';
              this.msg = '此操作将进行保存验证，是否继续？'
            } else if(flag2){
              this.$message({
                showClose: true,
                message: '盘点数量不能为负数！',
                type: 'error'
              });
            }else {
              this.$message({
                showClose: true,
                message: '请将盘点数量填写完整！',
                type: 'error'
              });
            }
          } else {
            this.fullscreenLoading = false;
            this.$message({
              showClose: true,
              message: '请将信息填写完整！',
              type: 'error'
            });
            console.log('error submit!!');
            return false;
          }
        });

      },
      submitForm(formName) { //提交盘点单
        var reqParams = this.list;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var flag = true;
            var flag2 = false;
            // console.log("循环上面:"+JSON.stringify(this.list))
            this.list.productList.forEach((item) => {
              if (item.ncountnum === ''||item.ncountnum ===null) {
                // console.log("index:" + JSON.stringify(item));
                flag = false;
                return;
              };
              if(item.ncountnum<0){
                flag2 =true;
              }
            });
            if (flag&&!flag2) {
              this.methodName = 'submit';
              this.modelFlag = true;
              this.butflag = true;
              this.msgShow =false;
              this.butmsg='确认';
              this.msg = '此操作将提交盘点单，是否继续？'
            }else if(flag2){
              this.fullscreenLoading = false;
              this.$message({
                showClose: true,
                message: '盘点数量不能为负数！',
                type: 'error'
              });
            } else {
              this.$message({
                showClose: true,
                message: '请盘点数量填写完整！',
                type: 'error'
              });
            }
          } else {
            this.fullscreenLoading = false;
            this.$message({
              showClose: true,
              message: '请将信息填写完整！',
              type: 'error'
            });
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>
<style scoped>
  .prinbox {
    margin: 20px 0;
  }

  .tablebox .tabletitleinput {
    width: 8rem;
    margin: 6px 2px
  }

  .tablebox .tabletitleinput.el-date-editor.el-input,
  .tablebox .tabletitleinput.el-date-editor.el-input__inner {
    width: 8rem !important;
  }

  .tablebox .tabletitleinput .el-input__inner {
    border: 1px solid #DCDFE6 !important;
    height: 2rem;
  }
  tr.isred{
    color:#F56C6C
  }
  tr.isgreen{
    color:#56B8AA;
  }
  .content-a-upload {
    position: relative;
    padding:  8px 10px;
    margin: 0 0 20px 20px;
    height: 16px;
    width: 100px;
    /*font: 400 16px/60px "宋体";*/
    text-align: center;
    cursor: pointer;
    color: #FFF;
    background: #e6a23c;
    /*border: 1px solid #ddd;*/
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    /*float: left;*/
    text-decoration: none;
  }
  .content-a-upload input {
    position: absolute;
    font-size: 12px;
    height: 33px;
    width: 111px;
    right: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
  .content-a-upload:hover {
    color: #FFF;
    background: #e6a23c;
    /*border-color: #ccc;*/
    text-decoration: none
  }
</style>



// WEBPACK FOOTER //
// src/views/stock/zengpan.vue